import { render, staticRenderFns } from "./KelasOfflineEdit.vue?vue&type=template&id=f87d6818&scoped=true"
import script from "./KelasOfflineEdit.vue?vue&type=script&lang=js"
export * from "./KelasOfflineEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f87d6818",
  null
  
)

export default component.exports